import {Component} from '@angular/core';

@Component({
    selector: 'app-headline-content',
    templateUrl: './headline-content.component.html',
    styles: [],
    standalone: false
})
export class HeadlineContentComponent {
}
